import Vue from 'vue'
import Router from 'vue-router'

const Login = () => import('./components/Login.vue')
const Home = () => import('./components/Home.vue')
const Welcome = () => import('./components/Welcome.vue')

// User Components
const Users = () => import('./components/user/Users.vue')
const InsideUsersList = () => import('./components/user/insideUsersList.vue')
const OpenVipList = () => import('./components/user/openVipList.vue')
const SalemanList = () => import('./components/user/salemanList.vue') // 业务员管理
const UserTixianList = () => import('./components/user/userTixianList.vue')
const JifenDuihuanList = () => import('./components/user/jifenDuihuanList.vue')
const JifenList = () => import('./components/user/jifenList.vue')

// Activity Components
const ActivityList = () => import('./components/activity/activityList.vue')
const ActivityApplyList = () => import('./components/activity/activityApplyList.vue')
const NotificationList = () => import('./components/activity/notificationList.vue')

// Ziliao (Resources) Components
const GradeList = () => import('./components/ziliao/gradeList.vue')
const SubjectList = () => import('./components/ziliao/subjectList.vue')
const CategoryList = () => import('./components/ziliao/category.vue')
const ZiliaoAdd = () => import('./components/ziliao/ZiliaoAdd.vue')
const GoodsList = () => import('./components/ziliao/List.vue')

// Pigai (Correction) Components
const PigaiList = () => import('./components/ziliao/pigai/pages/pigaiList.vue')
const PigaiDetail = () => import('./components/ziliao/pigai/pages/pigaiDetail.vue')
const PigaiEditor = () => import('./components/ziliao/pigai/pages/PigaiEdit.vue')

// Zixun (News) Components
const ZixunList = () => import('./components/zixun/zixunList.vue')
const ZixunCategoryList = () => import('./components/zixun/zixunCategoryList.vue')
const ZixunEdit = () => import('./components/zixun/zixunEdit.vue')

// System/Admin Components
const LunboList = () => import('./components/system/Lunbo.vue')
const ManagedList = () => import('./components/admin/ManagedList.vue')
const Roles = () => import('./components/admin/Roles.vue')

// Goods Components
const Cate = () => import('./components/goods/Cate.vue')
const AddActivity = () => import('./components/goods/AddActivity.vue')
const UserActivityManaged = () => import('./components/goods/UserActivityManaged.vue')
const GoodActivityList = () => import('./components/goods/ActivityList.vue')
const Params = () => import('./components/goods/Params.vue')
const SetGoodInvoice = () => import('./components/goods/SetGoodInvoice.vue')
const DwGoodEndTime = () => import('./components/goods/DwGoodEndTime.vue')
const Add = () => import('./components/goods/Add.vue')

// Order Components
const Order = () => import('./components/order/Order.vue')
const DwGoodsList = () => import('./components/order/DwGoodsList.vue')
const DwOrder = () => import('./components/order/DwOrder.vue')
const OrderDetail = () => import('./components/order/Detail.vue')
const DwOrderDetail = () => import('./components/order/DwDetail.vue')

// Notice Components
const NoticeList = () => import('./components/notice/NoticeList.vue')
const NoticeAdd = () => import('./components/notice/Add.vue')
const FeedbackList = () => import('./components/notice/FeedbackList.vue')

Vue.use(Router)

const router = new Router({
    routes: [
        { path: '/', redirect: '/home' },
        { path: '/login', component: Login },
        {
            path: '/home',
            component: Home,
            redirect: '/welcome',
            children: [
                { path: '/welcome', component: Welcome },
                { path: '/users', component: Users },
                { path: '/insideUsersList', component: InsideUsersList },
                { path: '/openVipList', component: OpenVipList },
                { path: '/jifenDuihuanList', component: JifenDuihuanList },
                { path: '/goodJifenTypes', component: JifenList },
                { path: '/activityList', component: ActivityList },
                { path: '/activityApplyList', component: ActivityApplyList },
                { path: '/notificationList', component: NotificationList },
                { path: '/lunboList', component: LunboList },
                { path: '/gradeList', component: GradeList },
                { path: '/subjectList', component: SubjectList },
                { path: '/categoryList', component: CategoryList },
                { path: '/goodActivityList', component: GoodActivityList },
                { path: '/pigaiList', component: PigaiList },
                { path: '/pigaiDetail', component: PigaiDetail },
                { path: '/pigaiEditor', component: PigaiEditor },

                // Zixun (News) Routes
                { path: '/zixunList', component: ZixunList },
                { path: '/zixunCategoryList', component: ZixunCategoryList },
                { path: '/zixunEdit', component: ZixunEdit },

                { path: '/salemanList', component: SalemanList },
                { path: '/userTixianList', component: UserTixianList },
                { path: '/roles', component: Roles },
                { path: '/categories', component: Cate },
                { path: '/userActivityManaged', component: UserActivityManaged },
                { path: '/params', component: Params },
                { path: '/goods', component: GoodsList },
                { path: '/goods/add', component: Add },
                { path: '/goods/ziliaoAdd', component: ZiliaoAdd },
                { path: '/goods/addActivity', component: AddActivity },
                { path: '/goods/dwGoodEndTime', component: DwGoodEndTime },
                { path: '/setGoodInvoice', component: SetGoodInvoice },

                { path: '/orders', component: Order },
                { path: '/dwOrders', component: DwOrder },
                { path: '/dwGoodsList', component: DwGoodsList },
                { path: '/orders/detail', component: OrderDetail },
                { path: '/orders/dwdetail', component: DwOrderDetail },

                { path: '/noticeList', component: NoticeList },
                { path: '/feedbackList', component: FeedbackList },
                { path: '/noticeList/add', component: NoticeAdd },
                { path: '/managedList', component: ManagedList }
            ]
        }
    ]
})

// 挂载路由导航守卫
router.beforeEach((to, from, next) => {
    // 允许开发环境直接访问，方便调试
    if (process.env.NODE_ENV === 'development') return next()

    if (to.path === '/login') return next()

    // 获取token
    const tokenStr = window.sessionStorage.getItem('token')
    if (!tokenStr) return next('/login')

    next()
})

export default router